/* eslint-disable max-len */
import { organizationusersList } from "./apiSlice";

const ObserverDetails = organizationusersList.injectEndpoints({
    tagTypes: ['Observer', 'ObserverActivityHistory', 'SelectedObserverPatient'],
    endpoints: (builder) => ({
        addObserver: builder.mutation({
            query: org => ({
                url: `/observers`,
                method: 'POST',
                body: org
            }),
            invalidatesTags: ['Observer']
        }),
        getObservers: builder.query({
            query: (searchParams) => `observers?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'Observer',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'Observer', id: _id }))
            ] : []
        }),
        viewObserver: builder.query({
            query: (id) => `/observers/${id}`,

            providesTags: (result, error, arg) => [{ type: 'Observer', id: arg }],
            invalidatesTags: ['ObserverActivityHistory']
        }),
        editObserver: builder.mutation({
            query: ({ id, body }) => ({
                url: id !== undefined ? `/observers/${id}` : `/observers/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Observer', 'ObserverActivityHistory']
        }),
        getObsPatientSubdivisions: builder.query({
            query: (searchParams) => `observers/list-patients?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'SelectedObserverPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'SelectedObserverPatient', id: _id }))
            ] : [],
        }),
        linkPatienttoObserver: builder.mutation({
            query: ({ userid, body }) => ({
                url: `observers/link-patients/${userid}`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['SelectedObserverPatient', 'Observer']
        }),
        deletePatientAssociatedObserver: builder.mutation({
            query: ({ observer_id, patient_id }) => {
                return {
                    url: `observers/unlink-patients/${observer_id}?patient_id=${patient_id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: ['SelectedObserverPatient', 'Observer'],
        }),

        exportObserversList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `observers/export-user-list?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        // activity history listing
        observerActivityHistoryList: builder.query({
            query: (searchParams) => `observers/list-changes?${searchParams}`,
            providesTags: ['ObserverActivityHistory']

        }),
        exportObserverActivityHistory: builder.mutation({
            query: ({ sort, columns, username, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `observers/export-profile-changes?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "target_user_name": username, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        // delete observer
        deleteObserver:builder.mutation({
            query:(body)=>({
                url:`observers/delete-observers`,
                method:'PATCH',
                body:body,
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Observer', id: arg.id },'Observer']
        }),
    }),
    overrideExisting: false
})

export const {
    useGetObserversQuery,
    useAddObserverMutation,
    useViewObserverQuery,
    useEditObserverMutation,
    useLazyGetObsPatientSubdivisionsQuery,
    useLinkPatienttoObserverMutation,
    useDeletePatientAssociatedObserverMutation,
    useExportObserversListMutation,
    useObserverActivityHistoryListQuery,
    useExportObserverActivityHistoryMutation,
    useLazyViewObserverQuery,
    useDeleteObserverMutation,
} = ObserverDetails